export default __webpack_public_path__ + "static/media/exstraSign.9e12cc24.png";